/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-redeclare */
import {StringifyOptions} from 'query-string';

/* eslint-disable @typescript-eslint/no-empty-function */
export enum ObjectType {
    User = 5,
    Space = 10,
    Group = 15,
    Repository = 20,
    Doc = 25,
    Sheet = 30,
    // 知识本类型本质还是文档，该35仅用于权限申请标识
    Book = 35,
    PPT = 40,
    DATASHEET = 45,
}

export const MemberStatus = {
    Delete: -15,
    Broken: -10,
    Refuse: -5,
    Invited: 10,
    Applied: 15,
    Normal: 20,
};

export const MemberType = {
    User: 5,
    RlGroup: 10,
    EmailGroup: 15,
    Department: 20,
};

export const OwnerType = {
    User: 5,
    FREE: 10,
    VIP: 15,
    Tenant: 20,
    Space: 25,
    Group: 30,
    Repository: 35,
};

export const RepositoryScope = {
    // 公开知识库
    SpaceReader: 11,
    // 半公开知识库
    SpaceReaderLimit: 12,
    // 私密知识库
    Repository: 20,
};

export const RepositorySourceType = {
    normal: 10, // 默认普通知识库
    fromOkr: 15, // 从任务okr创建的知识库
    fromWiki: 50, // wiki迁移过来的知识库
    notice: 25, // 部门公告类型知识库
};

export const PageScope = {
    PagePublic: 5,
    PagePublicEdit: 6,
    pageClosed: 20,
};

export const Role = {
    Owner: 'AAOwner',
    Admin: 'Admin',
    Member: 'Member',
    Reader: 'Reader',
    DocMember: 'DocMember',
    DocReader: 'DocReader',
    LimitedReader: 'LimitedReader',
    DocAdmin: 'DocAdmin',
};

// 「最近编辑者」申请页面使用
export const ApplyRole = {
    DocEditor: 'DocEditor',
};

export const ROLE_MAP = {
    [`${Role.Owner}`]: '管理员',
    [`${Role.Admin}`]: '管理员',
    [`${Role.Member}`]: '成员',
    [`${Role.Reader}`]: '只读成员',
    [`${Role.DocMember}`]: '可编辑',
    [`${Role.DocReader}`]: '可阅读',
    [`${Role.DocAdmin}`]: '页面管理员',
};

export const DepartmentRole = {
    // 超管
    AAOwner: 'AAOwner',
    // 管理员
    Admin: 'Admin',
    // 成员
    Member: 'Member',
};

export const LogAction = {
    Create: 10,
    Retrieve: 15,
    Update: 20,
    Delete: 25,
    Comment: 30,
    underLineComment: 32,
    Export: 35,
    Share: 40,
    Follow: 45,
    Recovery: 50,
    Restore: 52,
    Copy: 55,
    Move: 60,
    MoveNew: -60, // 移动到新知识库，记录日志
    Like: 61,
    // 知识库移入移出
    MoveIn: 100,
    MoveOut: 105,
    MoveOutApproval: 108,
    MoveInApproval: 102,
    TagChange: 125, // 标签变更
    //
    Mention: 62,
    MentionInDoc: 63, // 文档内提及，包括评论提及
    MemberInvite: 65,
    WikiTransferMemberInvite: 66,
    MemberApply: 70,
    MemberAgree: 75,
    MemberDisagree: 80,
    MemberChange: 85,
    MemberDelete: 90,
    MemberLeave: 95,
    RenameDoc: 21,
    Download: 36,
    CloseHistorical: 71,
    OpenHistorical: 70,
    OpenExcelMentionPeople: 72,
    ClosExcelMentionPeople: -72,
    OpenPersonalDynamicState: 2, // 打开个人动态
    ClosePersonalDynamicState: -2,
    ChangeRepositoryPublic: 5, // 将知识库可见范围设置为 公开
    ChangeRepositoryLimited: 4,
    ChangeRepositoryPrivate: 3,
    OpenWaterMark: 6, // 打开显示水印
    CloseWaterMark: -6,
    // 打开文档禁止只读成员复制内容
    DocForbidReaderCopy: -14,
    // 关闭文档禁止只读成员复制内容
    DocCloseForbidReaderCopy: 14,
    // 自动设置为自己创建的页面的页面管理员
    AutoSetAsAdmin: 13,
    OpenForbidReaderCopy: 7, // 打开禁止只读成员复制内容
    CloseForbidReaderCopy: -7,
    OpenForbidReaderDownLoad: 8, // 打开禁止只读成员下载附件
    CloseForbidReaderDownLoad: -8,
    OpenForbidHelperRecommend: 9, // 打开禁止通过智能知识助手推荐
    CloseForbidHelperRecommend: -9,
    OpenBrowseRecords: 77, // 打开关闭用户最近浏览详情记录
    CloseBrowseRecords: 76,
    OpenForbidPrintPdf: 73, // 打开禁止只读成员打印/导出PDF
    CloseForbidPrintPdf: -73,
    OpenReaderInviteReader: 74, // 打开允许查看者邀请页面查看者
    CloseReaderInviteReader: -74,
    OpenEditorInviteEditor: 78, // 打开允许编辑者邀请页面编辑者
    CloseEditorInviteEditor: -78,
    OpenMemberInviteReader: 79, // 打开允许知识库成员邀请知识库只读成员
    CloseMemberInviteReader: -79,
    ExportRepositoryAuthorityPages: 12, // 知识库页面权限导出
    DocOpen: 151, // 文档公开
    DocClose: 152, // 文档关闭公开
    DocSetAutoClose: 153, // 文档设置公开时效性
    DocCancelAutoClose: 154, // 文档取消公开
    DocAutoClose: 155, // 文档自动关闭
    openQACenter: 38, // 开启知识库智能问答
    closeQACenter: -38, // 关闭知识库智能问答

    removeRepositoryAuth: 211,
    removeBookAuth: 212,
    exportPower: 12, // 导出了当前知识库及页面的权限
};

export const MessageSource = {
    Must: 'must',
    //
    Me: 'me',
    Permission: 'permission',
    User: 'user',
    Repository: 'repository',
    Doc: 'doc',
    Mention: 'mention',
    subscribe: 'subscribe',
    reply: 'reply',
};

export const MentionFrom = {
    Comment: 1, // 划线评论提及
    Document: 2, // 文章内的提及
    BottomComment: 3, // 底部评论提及
    SheetDate: 4, // 数据表-日历列
};

export const Operation = {
    Apply: 'apply',
    Agree: 'agree',
    ReadableApply: 'readableApply',
    // accept is for doc
    Accept: 'accept',
    Disagree: 'disagree',
    Invite: 'Invite',
    Role: 'role',
};

export const ObjectStatus = {
    Shred: -20,
    Delete: -15,
    Normal: 20,
};

// 部门、组织是否存在
export enum DepStatus {
    notExist = -15,
    exist = 20,
}

// 部门、组织开通状态
export enum OrgDepStatus {
    notOpen = -15, // 开通
    open = 20, // 未开通部门
}

// 部门、组织是否有效
export enum ErpDepStatus {
    expired = -15, // 失效
    Normal = 20, // 有效
}

export const DEPARTMENT_ERROR_TIP = '此部门不存在，若想申请开通部门知识库，请联系 houjunying';
export const DEPARTMENT_MOVE_TIP = '该部门已失效或不存在，若须将知识库移出部门请联系 houjunying';
export const DEPARTMENT_NOT_OPEN_TIP = '此部门未开通，若要申请开通部门知识库，请联系 houjunying';
export const DEPARTMENT_EXPIRED_TIP = '该部门暂未开通，若要申请开通部门知识库，请联系 houjunying';
export const ORGANIZATION_EXPIRED_TIP = '该组织暂未开通，若想申请开通组织知识库，请联系 houjunying';
export const GU_DEPARTMENT_ERROR_TIP = '您无权访问该组织知识库';
export const GU_DEPARTMENT_LOSE_EFFICACY_TIP = '该组织已不存在或已失效';

export enum EnumShareInviteType {
    share = 'share',
    invite = 'invite',
    shareinviteBtn = 'shareinviteBtn',
}
export const ShareInviteModalType = {
    share: 'share',
    invite: 'invite',
    show: 'show',
};
export const ShareInviteModalSource = {
    docs: 'docs',
    recentDocs: 'recentDocs',
    department: 'department',
    repository: 'repository',
    personalPage: 'personalPage',
};
export const shareInviteDisplayType = {
    popper: 'popper',
    modal: 'modal',
};
export const MAX_SUGS_NUM = 200;
export const MessageStatus = {
    ...ObjectStatus,
    Unread: 10,
};
// 设置入口tabs切换的id
export enum EntryTabsKey {
    Message = 'messageTabpane',
    SmartBeta = 'smartBetaTabpane',
    Other = 'otherTabpane',
    InterfaceDisplay = 'interfaceDisplay',
}
// 知识库角色和页面角色存在映射关系 页面判断权限的时候只需要关注页面角色信息就行
// DocMember => 成员
// DocReader => 只读成员
// DocAdmin => 文档管理员
export const DocRole = {
    Member: 'DocMember',
    Reader: 'DocReader',
    DocAdmin: 'DocAdmin',
};

// 知识本是否继承知识库权限
export const InheritRepo = {
    Inherit: 1,
    Not_Inherit: 2,
};

export const RepositoryIntroMaxLength = 150;
export const RepositoryNoticeMaxLength = 200;
export const UploadImageMaxSize = 5 * 1024 * 1024;

export const UpdateType = {
    Logo: 'logo',
    Name: 'name',
    Intro: 'intro',
    Notice: 'notice',
    Safe: 'scope',
    Settings: 'settings',
    Avatar: 'avatar',
    Recommend: 'recommend',
    Comment: 'comment',
};

export const STATUS = {
    none: 'none',
    success: 'success',
    noData: 'noData',
    error: 'error',
    scrollError: 'scrollError',
    loading: 'loading',
    noSearch: 'noSearch',
    searchError: 'searchError',
    noScrollData: 'noScrollData',
    confirmLoading: 'okLoading',
} as const;
export type IStatus = typeof STATUS[keyof typeof STATUS];

export const RTE_STATUS = {
    success: 'success',
    fail: 'fail',
    saving: 'saving',
    timeout: 'timeout',
    init: 'init',
    draft: 'draft',
    noNetWork: 'noNetWork',
};

export const RTE_WS_STATUS = {
    wsOffline: 'wsOffline',
    wsOnline: 'wsOnline',
    wsConnecting: 'wsConnecting',
};

export enum MemberSearchType {
    All = 'all',
    User = 'user',
    Group = 'group',
    EmailGroup = 'emailGroup',
}

export const ModalInputWidthAdd = 3; // 防止获取到的输入内容宽度太小，导致输入框光标可能看不到

export enum EDITOR_MODE {
    preview = 'preview',
    edit = 'edit',
    history = 'history',
    meeting = 'meeting',
    // 读写合一模式
    normal = 'normal',
    version = 'version',
}

export enum DepartmentTabs {
    Index = 'index',
    KB = 'kb',
    Members = 'members',
    Statistics = 'statistics',
    Setting = 'setting',
    RecycleBin = 'recyclebin',
    PowerRecycle = 'powerRecycle',
}

export enum SettingTabs {
    // Members = 'members',
    Approval = 'approval',
    Models = 'models',
    Security = 'security',
    Log = 'log',
    Super = 'super',
    User = 'user',
    SmartQA = 'smartQA', // 智能问答
    AuthRisk = 'authRisk'
}

export enum KnowledgeBaseHomeTabs {
    recent = 'recent',
    dashboard = 'dashboard',
}

export const SidebarWidthName = 'sidebarWidth';
export const selfAdaption = 'selfAdaption';

export const HEAD_PADDING = 48;
export const SAFE_WIDTH = 200;
export const HEAD_MINSPACE = 40;
export const EDITOR_TEXT_MIN_WIDTH = 416;
export const EDITOR_TEXT_MIN_WIDTH_CONTENT_ONLY = 360;

export const EDITOR_TEXT_MAX_WIDTH = 846;
export const EDITOR_TEXT_MAX_WIDTH_CARD_VIEW = 1274; // 设置该值，卡片的最大宽度为 1224 px
export const EDITOR_TEXT_MAX_WIDTH_KU_SHARE = 1200;
export const EDITOR_MINWIDTH = 500;
export const RTE_MINWIDTH = 678;


// 非部门下的groupGuid
export const DEFAULT_GROUP_GUID = 'pKzJfZczuc';

// 新建知识库默认值
export const DEFAULT_CREATE_REPO = {
    visible: false,
    isInList: false,
    setReload: () => { },
};

export const OPEN_TAB = {
    openTabMsg: 0,
    openTabSmartBeta: 1,
} as const;
// 相当于 type OpenType = 0 ｜ 1
export type OpenType = typeof OPEN_TAB[keyof typeof OPEN_TAB];

// 设置弹窗默认状态
export const DEFAULT_OPEN_SETTING = {
    visible: false,
    openTabMsg: OPEN_TAB.openTabMsg,
};

export const DEFAULT_APP_ID = '1';

// 主页切换 最近更新 和 成员动态 一屏高度
export const HOME_SCROLL_HEIGHT = 700;

// 刷新失败特有id
export const UPDATE_FAILED = 'upDateFailed';

// 初始化时给标签一个安全宽度
export const TAG_SAFE_WIDTH = 223;
// 面包屑后面的公开icon的安全宽度
export const PUBLIC_TAG_WIDTH = 54;

export const ENVIRONMENT_LEVEL = {
    online: 'online',
    gray: 'gray',
    qa: 'qa',
    local: 'local',
    rd: 'rd',
};
// 水印jsdk
export const WATERMARK_JSDK = 'https://jsdk.baidu.com/jsdk/monitor?serviceid=2a8c55210a9d898eccc13bf2a5152b6c';

export const inheritListType = {
    doc: 'doc',
    directory: 'directory',
};

// 首页改版
export enum HomePageTabMenu {
    recently = 'recently',
    collection = 'collection',
    aboutme = 'aboutme',
}

export const LIST_STATUS = {
    NORMAL: 0,
    LOADING: 1,
    FINISH: 2,
    FAILED: 3,
    ALL_FAILED: 4,
    EMPTY: 5,
    ALL_EMPTY: 6,
    STAR_ALL_FAILED: 7,
    STAR_LIST_EMPTY: 8,
    STAR_HOME_EMPTY: 9,
    NOSECONDPAGE: 10,
} as const;
export type ListStatus = typeof LIST_STATUS[keyof typeof LIST_STATUS];

export const FOLLOW_TYPE = {
    user: 5,
    department: 15,
    repository: 20,
    doc: 25,
} as const;
export type FollowType = typeof FOLLOW_TYPE[keyof typeof FOLLOW_TYPE];

export const GENURLTYPE = {
    doc: 'doc',
    repository: 'repository',
    department: 'department',
} as const;

export type GenUrlType = typeof GENURLTYPE[keyof typeof GENURLTYPE];

export const SCROLL_LOAD_LIMIT_HEIGHT = 5;

export const IMPORTANT_DOC_TAGS = {
    leaderAt: '上级@你',
    leaderComment: '上级评论',
    leaderPublish: '上级发布',
    leaderlike: '上级点赞',
    likes: '多人点赞',
    comments: '多人评论',
    edits: '多人编辑',
    updates: '最近更新',
} as const;
export type IImportantDocTags = typeof IMPORTANT_DOC_TAGS[keyof typeof IMPORTANT_DOC_TAGS];

export const URL_SOURCE = {
    // 如流搜索
    rlSearch: 101,
    // 内搜
    ns: 102,
    // 个人知识库智能知识助手
    AIAssistant_PersonalKnowledge: 121,
    // 知识库首页智能知识助手
    AIAssistant_KnowledgeHome: 128,
    // 智能知识助手服务号
    AIAssistant_ServiceAccount: 122,
    // 知识广场智能知识助手
    AIAssistant_KnowledgeTab: 125,
    // 文档tab智能知识助手
    AIAssistant_DocumentTab: 126,
    // 文档tab-榜单
    documentTabValueList: 164,
    // 知识库搜索
    rlkbSearchFromPopper: 103,
    // 知识库落地页搜索
    rlkbSeachFromSearchPage: 100,
    // 知识库星链卡片上的百科按钮
    baikeBtnFromStarChain: 104,
    // 首页-快捷访问
    homePageCommonKnowledge: 132,
    // 首页-最近
    homePageRecent: 134,
    // 首页-星标
    homePageCollection: 135,
    // 首页-关于我
    homePageAboutMe: 136,
    // 知识库侧边栏-目录树
    sideBarDocs: 137,
    // 知识库主页-最近更新
    sidebarRepoHomePageRecentUpdate: 138,
    // 知识库侧边栏-标签
    sidebarTag: 139,
    // 知识库设置-审批列表与日志
    sidebarSettingApprovalAndLog: 140,
    // 底部评论文档引用
    bottomCommentMentionDoc: 143,
    // 正文引用文档
    docContentMentionDoc: 131,
    // 划线评论文档
    underlineCommentMentionDoc: 130,
    // 新个人主页-我公开发布列表
    PersonalHomePublishList: 148,
    // 新个人主页-我获币及获赞列表
    PersonalHomeGainCoinAndLikeList: 151,
    // 新个人主页-我送币列表
    PersonalHomeSendCoinList: 152,
    // 新个人主页-动态列表页面
    PersonalHomeDynamicPage: 147,
    // 新个人主页-动态列表卡片
    PersonalHomeDynamicCard: 146,
    // 新个人主页-可用知识币弹窗
    PersonalHomeUseableCoinDialog: 145,
    // 知识库侧边栏-目录树
    privateNoPowerSideBarDocs: 144,
    // 个人卡片文档点击
    PersonalCardDocList: 149,
    PersonalPagePublishDialog: 150,
    // 公开好文点击
    giveCoinDocList: 153,
    // 首页-榜单
    homeHighValueList: 159,
    // 发现-feed
    findPageRecommendFeedList: 157,
    // 发现-榜单
    findPageRecommendHotList: 158,
    // 发现-高价值知识榜
    findPageHighValue: 180,
    // 部门消息-高价值文档推荐
    depMessageDocFeed: 177,
    // 部门消息-亲密度投币文档推荐
    depMessageCoinFeed: 178,
    // 部门消息-助手文档推荐
    depMessageAssistantFeed: 179,
    // 发现-知识达人周榜
    findPageKowledgeExpertWeekList: 181,

    // 智能评分，专词推荐文档
    AIAgentSubjectWordRecommendDoc: 191,

    // 新人活动
    NewUserActivity: 192,
    // 发现页面-身边人已获币/投币文档
    findPageAroundPeopleCoinDoc: 193,
};

export const DOC_URL_SOURCE = [
    URL_SOURCE.AIAssistant_DocumentTab,
    URL_SOURCE.AIAssistant_KnowledgeHome,
    URL_SOURCE.AIAssistant_KnowledgeTab,
    URL_SOURCE.AIAssistant_PersonalKnowledge,
    URL_SOURCE.AIAssistant_ServiceAccount,
    URL_SOURCE.PersonalHomePublishList,
    URL_SOURCE.giveCoinDocList,
    URL_SOURCE.findPageHighValue,
    URL_SOURCE.homeHighValueList,
    URL_SOURCE.PersonalHomeSendCoinList,
    URL_SOURCE.findPageRecommendFeedList,
    URL_SOURCE.documentTabValueList,
    URL_SOURCE.depMessageAssistantFeed,
    URL_SOURCE.depMessageDocFeed,
    URL_SOURCE.depMessageCoinFeed,
    URL_SOURCE.findPageAroundPeopleCoinDoc,
];


// 38 上箭头 40下箭头 13 回车 27 ESC 8 delete
export enum KEYCODE {
    ENTER = 13,
    UP_ARROW = 38,
    DOWN_ARROW = 40,
    ESC = 27,
    DELETE = 8,
}

export const SEARCH_PAGE_TYPE_VAL: {[index: string]: number} = {
    doc: 1,
    ku: -1,
    sheet: 4,
    book: 2,
    ppt: 6,
    personalHomePage: 9999,
};

export const SEARCH_QUICK_TYPE_VAL = {
    doc: 1,
    ku: -1,
    sheet: 4,
    book: 2,
    ppt: 6,
    dataSheet: 7,
    personalHomePage: 9999,
} as const;

export enum TYPE {
    ku = 'ku',
    page = 'page',
}

export const CITE_FROM = {
    content: 'content',
    comment: 'comment',
};

export const WsRetryCountLogMax = 5;

export const querystringConfig: StringifyOptions = {
    sort: false,
    encode: false,
};

// 错误码
export const errorAlertMap: any = {
    40134: '当前文档内不存在附件', // 附件不存在
    40135: '最多支持下载50个附件', // 附件总数超过支持打包的最大值
    40136: '全部附件大于2G，不支持下载', // 附件总大小超过2g
    40137: '请等待上一个下载任务完成', // 用户重复下载
    40138: '无下载权限，请联系知识库管理员开启权限', // 无权限下载
    40130: '请关联如流后使用', // 用户没绑定如流
};
export const CREATION_READ_TYPE = {
    accumulative: 0,
    yesterday: 1,
    sevenDays: 5,
    thirty: 10,
} as const;
// 相当于 type OpenType = 0 ｜ 1
export type CreationReadType = typeof CREATION_READ_TYPE[keyof typeof CREATION_READ_TYPE];

export const COIN_ACTIVITY_TYPE = {
    myDynamicSend: 1,
    myDynamicLike: 2,
    myDynamicCollect: 3,
    myDynamicReference: 4,
    myDynamicVisit: 5,
} as const;
export type CoinDynamicType = typeof COIN_ACTIVITY_TYPE[keyof typeof COIN_ACTIVITY_TYPE];

// 1 - 增加, 2 - 打赏他人, 3 - 清空, 4 - 奖励, 5 - 追回, 6 - 恢复
export const MYCOIN_CHANGE_TYPE = {
    produce: 1,
    reward: 2,
    clearChange: 3,
    bonus: 4,
    recover: 5,
    restore: 6,
} as const;

export const BONUS_TYPE = {
    nothing: 0,
    randomCoin: 1,
    publishDoc: 2,
    activity: 3,
    shareDoc: 4,
} as const;
export type BonusType = typeof BONUS_TYPE[keyof typeof BONUS_TYPE];

export const COIN_DIALOG_KNOWLEDGE_TYPE = {
    doc: 1,
    activity: 2,
} as const;
export type CoinDialogKnowledgeType = typeof COIN_DIALOG_KNOWLEDGE_TYPE[keyof typeof COIN_DIALOG_KNOWLEDGE_TYPE];

export type MyCoinChangeType = typeof MYCOIN_CHANGE_TYPE[keyof typeof MYCOIN_CHANGE_TYPE];

export const COIN_DETAIL_DIALOG_SOURCE = {
    UseableCoin: 'UseableCoin',
    ReceivedCoin: 'ReceivedCoin',
    LikeList: 'LikeList',
} as const;
export type CoinDetailDialogSource = typeof COIN_DETAIL_DIALOG_SOURCE[keyof typeof COIN_DETAIL_DIALOG_SOURCE];
// 文档来源类型
export const DocSourceType = {
    routine: 10, // 常规文档
    import: 60, // 导入的文档
};

// 部门类型
export const GroupType = {
    GUGroup: 'D+', // GU类型统称D+组织知识库
    DTGroup: 'D', // DT类型统称D部门知识库
};
export const IREPOSITORY_ROLE_STATUS = {
    Shred: -20, // 彻底删除
    Delete: -15, // 删除状态
    Normal: 20, // 正常状态
    Applied: 15, // 申请中
} as const;


export type IRepositoryRoleStatus = typeof IREPOSITORY_ROLE_STATUS[keyof typeof IREPOSITORY_ROLE_STATUS];

// 个人主页 tab类型&tab可见性
export enum PERSONAL_HOME_TAB_MENU {
    publish = 'publish',
    accredited = 'accredited',
    rewardCoin = 'rewardCoin',
    communityLike = 'communityLike',
}
export enum PERSONAL_HOME_VISIBILITY_STATUS {
    all = 'all',
    self = 'self'
}
export enum PERSONAL_HOME_REPOSITORY_SCOPE {
    // 私密
    privacy = 20,
    // 公开
    open = 11,
    // 受限
    beLimitedTo = 12
}
export enum PERSONAL_HOME_DOC_SCOPE {
    // 私密
    privacy = 20,
    // 公开
    open = 5,
    out = 6
}
export enum PERSONAL_HOME_GUIDANCE_STATUS {
    open = 'open',
    close = 'close'
}
export const KNOWLEDGE_PATH_NAME = {
    recycleBin: 'recycleBin',
    homeTag: 'homeTag',
    members: 'members',
    setting: 'setting',
    square: 'square',
    QACenter: 'QACenter',
};
export const PERSONAL_SHOW_REPOENTRY = {
    all: 'all',
    self: 'self',
} as const;
export type IPersenalShowRepoEntry = typeof PERSONAL_SHOW_REPOENTRY[keyof typeof PERSONAL_SHOW_REPOENTRY];

export enum FindTabs {
    recommend = 'recommend',
    highQuality = 'highQuality',
}
export enum HeadTabs {
    home = 'home',
    find = 'recommend',
    topList = 'highQuality',
}

export const QUESTION_ANSWER_SOURCE = {
    kuHelpWindow: 'kuHelpWindow',
    kuPage: 'kuChatRepoPage',
    kuSdkBroadside: 'kuSdkBroadside',
    rlImRobot: 'rlImRobot',
};

// 知识库问答是否开启 1开启，2关闭
export enum QAIsOpen {
    isOpen = '1',
    isClose = '2'
}

export enum ResignStatus{
    onJob = 0,
    noOnJob = 1,
}

// 知识库问答初始化状态，-1初始化失败， 1初始化中，2初始化完成
export enum QAInitStatus {
    failed = '-1',
    init = '1',
    success = '2'
}

// 知识库问答开启状态
export interface QuestionAnswerSwitch {
    chatRepo: QAIsOpen;
    chatRepoInitStatus: QAInitStatus;
    progress: string;
}
export const SquareSourceMap = {
    ku: '知识库',
    duForum: '产品论坛',
    duNews: '度新闻',
    baiJiaHao: '百家号',
    jingPinGuanChaShi: '竞品观察室',
    duSchool: '度学堂',
    miaoDongBaiKe: '秒懂百科',
    weChat: '微信公众号',
};
export const likeSourceType = {
    knowledgeKu: '知识库',
    productForum: '产品论坛',
    duLiveBroadcast: '度学堂',
    competingGoods: '竞品观察室',
    duNews: '度新闻',
    instantUnderStand: '秒懂百科',
    baiJiaHao: '百家号',
    weChat: '微信公众号',
};
export const SourceMapToLoggerReport = {
    ku: 'zhishiku',
    miaobi: 'zhishiku',
    zhishi_base: 'zhishiku',
    ku_high_value: 'zhishiku',
    baijiahao: 'baijiahao',
    family_news: 'duxinwen',
    family_chanpin: 'duluntan',
    dulearn: 'duokecheng',
    dulearn_course: 'duokecheng',
    dulearn_live: 'duzhibo',
    dulearn_short_video: 'duokecheng',
    dulearn_topic: 'duokecheng',
    external_link: 'jinpinguangchashi',
    miaodong_baike: 'miaodong',
    wechat: 'wechat',
    wiki: 'other',
    family: 'other',
    family_bbs: 'other',
    infoq: 'other',
    juejin: 'other',
    editor: 'other',
    my_file: 'other',
    jingyan: 'other',
    wenda_answer: 'other',
    zhishi_tongxue: 'other',
};

export const FindPageTabs = {
    aroundPeople: 'aroundPeople',
    HotKnowledge: 'HotKnowledge',
};

// 安全设置 - 开关值
export enum PageSecuritySwitchEnum {
    defaultClose = -1,
    kuOpen = 1,
    kuClose = 0,
    docOpen = 3,
    docClose = 2,
}

// 安全设置 - 开关打开list
export const PageSecurityIsSelected = [
    PageSecuritySwitchEnum.kuOpen,
    PageSecuritySwitchEnum.docOpen,
];

// 安全设置 - 文档设置覆盖知识库设置
export const PageSecurityIsExtendFromKu = [
    PageSecuritySwitchEnum.docClose,
    PageSecuritySwitchEnum.docOpen,
];

export enum linkOpenType {
    like = 'like',
    sendCoin = 'sendCoin',
}

// 审批的渠道
export enum APPROVAL_CHANNEL {
    Mail = 2, // 站内信
    ApprovalList = 3, // 审批列表
}

// 外部知识库复制移动异常类型
export enum InvalidType {
    noDocOrBook = 1,
    isPublic = 2,
}

// eslint-disable-next-line max-len
export const externalRepoAddPowerUrl = 'https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/munIPCvcFy/4PBu7aN3VoQM2E';

